<div class="card">
  <app-header
    titulo="Painel de Fluxo de Caixa"
    descricao="Painel de integração de fluxo de caixa"
  ></app-header>

  <p-tabView>
    <p-tabPanel header="Fluxo Caixa">
      <app-empresa-dropdown
        [(selecionadas)]="instanciaSelecionada"
        modo="unico"
        (funcaoChange)="onInstanciaChange($event)"
      />
      <p-calendar
        class="ml-3"
        [(ngModel)]="rangeDates"
        selectionMode="range"
        dateFormat="dd/mm/yy"
        [readonlyInput]="true"
        (onClose)="onDateChange($event)"
      />
      
      <p-button 
        label="Exportar" 
        icon="pi pi-download" 
        styleClass="p-button-success ml-3" 
        (onClick)="exportar()" 
        [loading]="loading">
      </p-button>

      <div class="mt-4">
        <p-tabView styleClass="tabview-custom" (onChange)="onChangeTab($event)">
          <p-tabPanel header="Despesas">
            <app-fluxocaixadespesas />
          </p-tabPanel>
          <p-tabPanel header="Receitas">
            <app-fluxocaixareceitas />
          </p-tabPanel>
          <p-tabPanel header="Custos Calculados">
            <app-fluxocaixacustoscalculados />
          </p-tabPanel>
        </p-tabView>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
